/**
 * Gender catalogue.
 *
 * Single-valued, like `BedType` — every guest has exactly one, so this
 * mirrors `bedTypes.ts` rather than the array-based `guestOptions.ts`.
 */
export const GENDERS = ['woman', 'man', 'other'];
export const GENDER_DEFINITIONS = {
    woman: { value: 'woman', label: 'Woman' },
    man: { value: 'man', label: 'Man' },
    other: { value: 'other', label: 'Other' },
};
export function isGuestGender(value) {
    return typeof value === 'string' && GENDERS.includes(value);
}
//# sourceMappingURL=genders.js.map